import { LoadingWrapper } from './styled';

export const LeftContentLoading = () => {
  return (
    <LoadingWrapper>
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <defs>
          <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0" stop-color="#615CED" />
            <stop offset="1" stop-color="#8aa2ff" />
          </linearGradient>
        </defs>

        <circle className="track" cx="32" cy="32" r="29" pathLength="100" />

        <g className="spin">
          <circle className="arc" cx="32" cy="32" r="29" pathLength="100" />
        </g>
      </svg>
    </LoadingWrapper>
  );
};
